import { CometChatTheme } from "@cometchat/uikit-resources";
import { createContext } from "react";

export const CometChatThemeContext = createContext({
    theme: new CometChatTheme({})
});
